import React from 'react';

import TemplateCreationSidepanel from '../ReviewTemplate/TemplateCreationSidepanel';
import { TemplateCreationSidePanelProvider } from '../ReviewTemplate/TemplateCreationSidepanel/TemplateCreationSidepanelContext';
import { ReviewTemplateProvider } from '../ReviewTemplate/common/ReviewTemplateContext';
import ReviewTemplateListV1 from './ReviewTemplateListV1';

const ReviewTemplateListWrapperV1 = () => (
  <TemplateCreationSidePanelProvider>
    <ReviewTemplateProvider>
      <ReviewTemplateListV1 />
      <TemplateCreationSidepanel />
    </ReviewTemplateProvider>
  </TemplateCreationSidePanelProvider>
);

export default ReviewTemplateListWrapperV1;
